<template>
  <div id="Notes">
    <!-- PRE PA CLUB CARD -->
    <v-card outlined>
       <v-layout row align-center justify-center class="grey lighten-4 pb-2 mx-0"> 
        <span class="title font-weight-regular  align-center mt-1">Notes</span>
      </v-layout>
      <v-container  pb-1>
        <v-layout column>
         
          
          <v-layout v-if="school.school_name !== 'University of North Dakota'" mt-2 pb-3>
            <span class="font-weight-light">{{school.notes}}</span>
          </v-layout>

          <v-layout v-else column mt-2 pb-3>
            <span>Entry Point 1</span>

            <span class="font-weight-light">
              Licensed/Certified Health Care Professional with minimum of 3 years experience.
              Applicants are accepted from all over the United States.
            </span>

            <span class="mt-3">Entry Point 2</span>
            <span class="font-weight-light">
              Science-based educational background and minimum of 500 (1000 preferred) hours of direct, supervised patient care.
              Applicants must be from North Dakota, Montana, Minnesota, or South Dakota. 
            </span>
          </v-layout>


        </v-layout>
      </v-container>
    </v-card>

  </div>
</template>


<script>
  
  export default {
    props: ['school'],
    data() {
      return  {
        showPaClubInfo: false,
      }
    }
  }
</script>

<style scoped>



 .card {
    border-radius: 10px;
  }
     #buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}

.link {
  text-decoration: none;
}
img {
  width:30px;
  height:30px;
}

.linkLogo {
  width:33px;
  height:33px;
  margin-left:10px;
  margin-right: 10px;
  border-radius:5px;
}

.tweetLogo {
  width:37px;
  height:37px;
  margin-left:10px;
  margin-right: 10px;
  border-radius:10px;
}
.blueHeading {
  color:#2196F3;
}

.background {
  background-color: rgb(255, 255, 255);
}

 
</style>


// WEBPACK FOOTER //
// src/components/Schools/SchoolDetail/Notes.vue